import styled from 'styled-components';

export const SignaturePlanListStyled = styled.div`
    display: flex;
    align-items: stretch;
    gap: 16px;
    width: 100%;
    margin-top: 24px;

    @media (max-width: 992px) {
        flex-direction: column;
    }
`;
